import { ERM_ACTIVITY_TOKEN_TYPE } from '../../constants/common-enums';
import isEmptyString from '../../helpers/is-empty-string';
import isValidTimestamp from '../../helpers/is-valid-timestamp';
import { getUsername } from '../../helpers/rememberme-cookie-helper';
import {
  deleteSsiErmCookies,
  getErmEnabledCookieValues,
  setErmEnabled
} from './ssi-erm-cookie-manager';
/**
 * Checks if user has valid enahanced remember me cookie
 * - if username cookie not matches with erm cookie username, we need to delete all ssi/erm cookies
 * @return {boolean} true if user has valid ERM cookie, false otherwise
 */
export const isErmEnabled = function() {
  const ermEnabled = getErmEnabledCookieValues() || {};
  const username = getUsername() || null;
  const ermUsername = (ermEnabled && ermEnabled.username) || null;
  if (!isEmptyString(ermUsername) && !isEmptyString(username) && username !== ermUsername) {
    deleteSsiErmCookies();
    return false;
  }
  // serverside activity_ref cookie set by /recognize will clear authRef
  return ermEnabled.authRef || isValidTimestamp(ermEnabled.date);
};

/**
 * Get ERM activity ref id from ermEbabled Cookie
 * @returns {string} activity reference id
 */
export const getErmActivityTokenFromCookie = function() {
  const ermEnabled = getErmEnabledCookieValues();
  return (ermEnabled && ermEnabled.authRef) || null;
};

/**
 * Get username from ermEbabled Cookie
 * @returns {string} activity reference id
 */
export const getUsernameFromErmCookie = function() {
  const ermEnabled = getErmEnabledCookieValues();
  return (ermEnabled && ermEnabled.username) || null;
};

/**
 * Get activity token from the list of issued token in the ERM Spawn response
 * @param {array} issuedTokens
 * @returns {string} token
 */
const getErmActivityToken = function(issuedTokens) {
  if (issuedTokens && Array.isArray(issuedTokens)) {
    const ermActivityToken = issuedTokens.find(
      iToken => iToken.token_type === ERM_ACTIVITY_TOKEN_TYPE
    );
    return (ermActivityToken && ermActivityToken.token) || null;
  }
  return null;
};

/**
 * Get Acitvity Token from Spawn response and set in the ermEnabeld Cookie
 * @param {array} issuedTokens
 */
export const setErmActivityToken = function(issuedTokens) {
  const activityToken = getErmActivityToken(issuedTokens);
  if (activityToken) {
    setErmEnabled(activityToken);
  }
};
